/**
 * ErrorPanel - Displays a three-phase viz execution error.
 *
 * Props:
 *   error       {{ phase, message, line }} | null
 *   onGoToLine  {fn(lineNumber)} - called when user clicks line badge
 */

const PHASE_STYLES = {
  syntax: {
    bg: 'bg-amber-50',
    border: 'border-amber-300',
    text: 'text-amber-800',
    badge: 'bg-amber-500 text-white',
    label: 'Syntax Error',
  },
  runtime: {
    bg: 'bg-red-50',
    border: 'border-red-300',
    text: 'text-red-800',
    badge: 'bg-red-500 text-white',
    label: 'Runtime Error',
  },
  plotly: {
    bg: 'bg-orange-50',
    border: 'border-orange-300',
    text: 'text-orange-800',
    badge: 'bg-orange-500 text-white',
    label: 'Plotly Error',
  },
};

export default function ErrorPanel({ error, onGoToLine }) {
  if (!error) return null;

  const style = PHASE_STYLES[error.phase] || PHASE_STYLES.runtime;

  return (
    <div className={`flex items-start gap-3 p-3 rounded-lg border ${style.bg} ${style.border}`}>
      <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${style.badge}`}>
        {style.label}
      </span>
      <span className={`flex-1 text-sm font-mono break-all ${style.text}`}>
        {error.message}
      </span>
      {error.line != null && (
        <button
          onClick={() => onGoToLine?.(error.line)}
          className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${style.badge} opacity-80 hover:opacity-100 transition`}
          title={`Go to line ${error.line}`}
        >
          Line {error.line}
        </button>
      )}
    </div>
  );
}
